import { ref, computed, reactive } from 'vue';
import { F as FontType, T as TextTransform, B as ButtonStyleKind, R as RadiusKind, M as MeasureUnit } from './chunks/maps.nxkzRTum.js';

const noteDefaultColorsStyles = {
  paragraph: "#000000",
  buttonText: "#ffffff",
  link: "#1C8BF1",
  buttonBackground: "#000000",
  secondaryButtonBackground: "#000000",
  secondaryButtonText: "#FFFFFF",
  background: {
    base: "#ffffff"
  },
  icon: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
};
const defaultColorStyles = {
  heading: "#000000",
  paragraph: "#000000",
  link: "#1C8BF1",
  buttonText: "#FFFFFF",
  buttonBackground: "#000000",
  secondaryButtonBackground: "#000000",
  secondaryButtonText: "#FFFFFF",
  background: {
    base: "#FFFFFF"
  },
  icon: "#000000",
  perks: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
};
const defaultFontsStyles = {
  heading: {
    spec: {
      key: "Playfair+Display",
      name: "Playfair Display",
      cssName: "Playfair Display",
      type: "serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "bold",
    textTransform: TextTransform.None
  },
  paragraph: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  formFieldName: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  other: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  perks: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  countdown: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  button: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  secondaryButton: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  }
};
const defaultButtonStyles = {
  note: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 8,
      right: 16,
      bottom: 8,
      left: 16,
      format: MeasureUnit.Em
    }
  },
  layer: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  },
  exit: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  },
  inliner: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  }
};
const defaultBackgroundStyles = {
  opacity: 100,
  cornerRadius: {
    kind: RadiusKind.Medium
  }
};
const defaultInlinerBackgroundStyles = {
  opacity: 100,
  cornerRadius: {
    kind: RadiusKind.Medium
  },
  border: {
    color: "#D9D9D9",
    thickness: 1
  }
};
const defaultOverlayStyles = {
  color: "#000000",
  opacity: 50
};

function useDefaultStyles(type) {
  const toolType = ref(type);
  const defaultButtonStylesByTool = computed(
    () => defaultButtonStyles[toolType.value] || defaultButtonStyles.layer
  );
  return reactive({
    colors: { ...defaultColorStyles },
    fonts: { ...defaultFontsStyles },
    button: { ...defaultButtonStylesByTool.value },
    secondaryButton: { ...defaultButtonStylesByTool.value },
    background: toolType.value === "inliner" ? { ...defaultInlinerBackgroundStyles } : { ...defaultBackgroundStyles },
    overlay: { ...defaultOverlayStyles }
  });
}

export { defaultFontsStyles as a, defaultButtonStyles as b, defaultBackgroundStyles as c, defaultColorStyles as d, defaultInlinerBackgroundStyles as e, defaultOverlayStyles as f, noteDefaultColorsStyles as n, useDefaultStyles };
//# sourceMappingURL=p-components.useDefaultStyles.js.map
